import { routes } from '@shared/routerHistory';
import { Constants } from '@shared/utils/constants';
export const PATHS_TO_VIEW_MAP = {
    [Constants.home]: {
        view: routes.home.name
    },
    marketplace: {
        view: routes.marketplace.name
    },
    [Constants.appsGallery]: {
        view: routes.marketplace.name
    },
    [Constants.newAppsGallery]: {
        view: routes.marketplace.name
    },
    [Constants.cloudsIndustryGallery]: {
        view: routes.marketplaceCloudsIndustry.name
    },
    [Constants.newCloudsIndustryGallery]: {
        view: routes.marketplaceCloudsIndustry.name
    },
    [Constants.productWithCompany]: {
        view: routes.appDetails.name
    },
    [Constants.productRoute]: {
        view: routes.commonPageDetails.name
    },
    [Constants.marketplaceCheckout]: {
        view: routes.checkout.name
    },
    'checkout/:entityId': {
        view: routes.checkout.name
    },
    'marketplace/order-confirmation': {
        view: routes.orderConfirmation.name
    },
    [Constants.csGallery]: {
        view: routes.marketplaceServices.name
    },
    [Constants.newCsGallery]: {
        view: routes.marketplaceServices.name
    },
    [Constants.consultingServicesOldProduct]: {
        view: routes.serviceDetail.name
    },
    [`${Constants.partnersAppSource}/*`]: {
        view: routes.marketplacePartners.name
    },
    [`${Constants.partnersAppSource}/:entityId/:tab`]: {
        view: routes.marketplacePartnerDetail.name
    },
    [`${Constants.partnersAppSource}/:entityId/:tab/contact`]: {
        view: routes.marketplacePartnerDetailContact.name
    },
    [`${Constants.partnersAppSource}/suggestion`]: {
        view: routes.marketplacePartnerSuggestion.name
    },
    [`${Constants.newPartnersAppSource}/*`]: {
        view: routes.marketplacePartners.name
    },
    [`${Constants.newPartnersAppSource}/:entityId/:tab`]: {
        view: routes.marketplacePartnerDetail.name
    },
    [`${Constants.newPartnersAppSource}/:entityId/:tab/contact`]: {
        view: routes.marketplacePartnerDetailContact.name
    },
    [`${Constants.newPartnersAppSource}/suggestion`]: {
        view: routes.marketplacePartnerSuggestion.name
    },
    [Constants.consultingServicesLegacyProduct]: {
        view: routes.serviceDetail.name
    },
    [Constants.campaignDetails]: {
        view: routes.campaigns.name
    },
    'user/my-favourites': {
        view: routes.userFavouriteDetail.name
    },
    'user/private-offers': {
        view: routes.privateOffers.name
    },
    [Constants.privateProductWithCompany]: {
        view: routes.privateOfferDetails.name
    },
    [Constants.privateProductRoute]: {
        view: routes.privateOfferDetails.name
    },
    sitemap: {
        view: routes.sitemap.name
    },
    redirect: {
        view: routes.redirect.name
    }
};
